var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.58342 0.360451C8.26265 0.0397954 7.74256 0.0399051 7.4219 0.360451C7.10102 0.681325 7.10102 1.2013 7.42201 1.52217L10.5782 4.67824L1.43841 4.67912C0.984792 4.67923 0.617148 5.04686 0.617148 5.50069C0.617258 5.95429 0.984901 6.32182 1.43851 6.32182L10.5787 6.32094L7.42168 9.47767C7.10091 9.79844 7.1009 10.3186 7.42168 10.6393C7.58212 10.7996 7.79228 10.8799 8.00255 10.8799C8.21271 10.8799 8.42287 10.7996 8.58331 10.6394L13.1423 6.08056C13.2964 5.92659 13.3829 5.71774 13.3829 5.49981C13.3828 5.28188 13.2963 5.07315 13.1422 4.91884L8.58342 0.360451Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default __webpack_public_path__ + "static/media/arr-right.ac556c0b7a90fa9425dee895b3ca55d4.svg";
export { ForwardRef as ReactComponent };